import React, { useEffect } from "react";
import { useStore } from "../../app/stores/store";
import { observer } from "mobx-react-lite";
import CategoryCard from "./CategoryCard";
import LoadingSpinner from "../common/LoadingSpinner";

const CategoryList = () => {
  const {
    categoryStore: { categories, loadCategories },
    userStore,
  } = useStore();

  useEffect(() => {
    loadCategories();
  }, [loadCategories, userStore.token]);

  if (!categories) return <LoadingSpinner />;

  return (
    <section id="services" className="pt-16 md:pt-24 pb-0">
      <div className="custom-container mx-auto px-4 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-center">
          {/* Left Title Section */}
          <div className="lg:col-span-2 text-start lg:text-left">
            <h2 className="text-4xl md:text-5xl font-bold text-primary">
              Our Visa Services
            </h2>
            <p className="mt-4 text-lg md:text-xl font-semibold">
              Trusted by thousands of happy clients
            </p>
            <p className="mt-4 text-lg md:text-xl">Fast. Honest. Reliable.</p>
          </div>

          {/* Right Cards Section */}
          <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {categories.map((category) => (
              <CategoryCard key={category.id} category={category} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default observer(CategoryList);
